import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ConfirmationService } from 'primeng/api';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DrawerModule } from 'primeng/drawer';
import { FileUploadModule } from 'primeng/fileupload';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { PopoverModule } from 'primeng/popover';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinner } from 'primeng/progressspinner';
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { TextareaModule } from 'primeng/textarea';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';

import { environment } from '@environments/environment';

@Component({
  selector: 'app-shell-admin-loader',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    AccordionModule,
    AutoCompleteModule,
    ButtonModule,
    CheckboxModule,
    ConfirmDialogModule,
    DatePickerModule,
    DialogModule,
    DividerModule,
    DrawerModule,
    FileUploadModule,
    InputNumberModule,
    InputTextModule,
    PopoverModule,
    ProgressBarModule,
    ProgressSpinner,
    SelectModule,
    SelectButtonModule,
    TableModule,
    TabsModule,
    TabViewModule,
    TagModule,
    TextareaModule,
    ToastModule,
    TooltipModule,
  ],
  templateUrl: './shell-admin-loader.component.html',
  providers: [ConfirmationService],
})
export class ShellAdminLoaderComponent implements OnInit {
  ngOnInit(): void {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${environment.REMOTE_URL_SHELL_ADMIN}/styles.css`;
    document.head.appendChild(link);
  }
}
